import React from 'react'
import { Link } from 'react-router-dom'
import { routePaths } from '../../urls'
import { postAssessmentIsSynced, alertUser } from '../../actions'
import { useStateValue } from '@State'
import { StatusMarker } from '../StatusMarker'
import { Checkbox } from '../Checkbox.js'

export const Assessments = () => {
  const [state, dispatch] = useStateValue()
  const { canvasUrl, assessments } = state
  let showNext = !!canvasUrl
  let setupIcon = showNext ? 'icon_checkmark' : 'icon_notification'

  const handleAssessmentSyncChange = async activityId => {
    const result = await postAssessmentIsSynced({ activityId }, dispatch)
    if (result) {
      alertUser(`Update successful!`, 2000, 'success')
    }
  }

  const generateTable = assessmentList => {
    if (!assessmentList) {
      return <div />
    }

    let tableRows = assessmentList.map((obj, i) => (
      <tr key={i}>
        <td>{obj.title}</td>
        <td>
          <Checkbox
            checked={obj.includeInLms}
            onChange={handleAssessmentSyncChange.bind(null, obj.id)} // eslint-disable-line react/jsx-no-bind
            title={obj.title}
          />
        </td>
      </tr>
    ))

    return (
      <table className="table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Sync to LMS</th>
          </tr>
        </thead>
        <tbody>{tableRows}</tbody>
      </table>
    )
  }

  const generateGroupDivs = groupsList => {
    if (!groupsList) {
      return <div />
    }

    let boxContent = groupsList.map((obj, i) => (
      <div className="group-box" key={i}>
        <div className="title-box">{obj.title}</div>
        {generateTable(obj.activities)}
      </div>
    ))

    return <div>{boxContent}</div>
  }

  return (
    <div>
      <div className="canvas-flex-wrapper">
        <div className="canvas-form-container">
          <h2>2. Choose Assessments</h2>
          <p>
            Select which MyEducator assessments you want to appear in
            Brightspace.
          </p>
          {generateGroupDivs(assessments.groups)}
          <Link to={routePaths.brightspaceSetup} className="btn btn-myed btn-default btn-default-myed">
            Back
          </Link>
          <Link to={routePaths.brightspaceTest} className="btn btn-myed btn-default btn-default-myed">
            Next
          </Link>
        </div>
        <div className="canvas-statusmarker-container">
          <StatusMarker iconType={setupIcon} />
        </div>
      </div>
    </div>
  )
}

